export default "__VITE_ASSET__C$kWfwte__"